import { createFileRoute } from '@tanstack/react-router'
import { ScenePage } from '@/features/workspaces/scenes'
import { scenesSearchSchema } from '@/features/workspaces/scenes/scenes-search-schema'

function ScenesRouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <ScenePage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/scenes/'
)({
  validateSearch: scenesSearchSchema,
  staticData: { layout: 'fluid' },
  component: ScenesRouteComponent,
})
